/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";

import './Works.css';

// Import ../../assets/recentprojects/
import Portfolio from '../../assets/recentprojects/train.jpg';
import Veritru from '../../assets/recentprojects/uhouse.jpg';
import Car from '../../assets/recentprojects/car.jpg';

const useStyles = makeStyles(() => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();
  const [projects] = useState([
    { 
      id: 1,
      title: 'E Ticket', 
      description: `A user-friendly platform for purchasing bus tickets online. It offers real-time bus schedules, seat selection, and secure payment options, ensuring a seamless travel booking experience.`,
      alter: 'E Ticket',
      image: Portfolio,
      links: {
        live: "https://a-5-rose.vercel.app/",
        frontend: "https://github.com/MD-SHihAb1/A-5",
        backend: "#",
      },
    },
    { 
      id: 2,
      title: 'Urb Home', 
      description: `A comprehensive website for buying houses online. Features property listings with detailed descriptions, virtual tours, and advanced search filters, simplifying the home-buying process.`,
      alter: 'Urb Home',
      image: Veritru,
      links: {
        live: "https://real-estate-4e1f5.web.app/",
        frontend: "https://github.com/MD-SHihAb1/A9",
        backend: "#",
      },
    },
    { 
      id: 3,
      title: 'Car Doctor', 
      description: `An online service connecting car owners with reliable mechanics for repairs. Includes diagnostic tools, booking options, and maintenance tips, ensuring quick and efficient car servicing.`,
      alter: 'Car Doctor',
      image: Car,
      links: {
        live: "https://car-doctor-e66f1.web.app/",
        frontend: "https://github.com/MD-SHihAb1/Car-client",
        backend: "https://github.com/MD-SHihAb1/Car-Server",
      },
    },
  ]);

  return (
    <div className="item-center">
      <section id="works">
        <Container component="main" className={classes.main} maxWidth="md">
          <div className="heading-wrapper">
            <p>My Projects</p>
          </div>
          {projects.map((project) => (
            <div className="project" key={project.id}>
              <div className="__img_wrapper">
                <img 
                  src={project.image} 
                  alt={project.alter} 
                  onMouseEnter={(e) => {
                    const img = e.currentTarget;
                    const containerHeight = img.parentElement.offsetHeight;
                    const imgHeight = img.offsetHeight;
                    const maxScroll = imgHeight - containerHeight;

                    if (maxScroll > 0) {
                      img.style.transform = `translateY(-${maxScroll}px)`;
                      img.style.transition = 'transform 1.5s linear'; 
                    }
                  }}
                  onMouseLeave={(e) => {
                    const img = e.currentTarget;
                    img.style.transform = 'translateY(0)'; 
                    img.style.transition = 'transform 1.5s linear';
                  }}
                />
              </div>
              <div className="__content_wrapper">
                <h3 className="title">
                  <TextDecrypt text={`${project.id}. ${project.title}`} />
                </h3>
                <p className="description">{project.description}</p>
                <div className="__button_wrapper">
                  <a href={project.links.live} target="_blank" rel="noopener noreferrer" className="btn">Live</a>
                  <a href={project.links.frontend} target="_blank" rel="noopener noreferrer" className="btn">Frontend</a>
                  <a href={project.links.backend} target="_blank" rel="noopener noreferrer" className="btn">Backend</a>
                </div>
              </div>
            </div>
          ))}
        </Container>
      </section>
    </div>
  );
};
